module.exports = __webpack_public_path__ + "img/Compass.61309ddf.svg";